"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("detect-it");Object.defineProperty(exports,"supportsPassiveEvents",{enumerable:!0,get:function(){return e.supportsPassiveEvents}});
//# sourceMappingURL=detect-passive-events.cjs.production.js.map
